import { useConfigContext } from 'providers/ConfigProvider';
import { useSettingsContext } from 'providers/SettingsProvider';
import SettingsForm from './SettingsForm';

function SettingsPage() {
  const config = useConfigContext();
  const settings = useSettingsContext();

  return (
    <div className="mx-auto max-w-lg" data-testid="page-settings">
      <SettingsForm settings={settings} />

      {/* App version */}
      <div className="mb-12">
        <div className="mb-4 text-xl">About</div>
        <div className="flex items-center text-sm">
          <div className="mr-2">Version</div>
          <div className="uppercase">{config.REACT_APP_VERSION_ID}</div>
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;
